<ez-navbar>
  <!-- Projected by the layout so that the navbar stays free of auth dependencies. -->
  <ez-account-menu />
</ez-navbar>
<main>
  <router-outlet />
</main>
